<template>
  <Modal
    framed
    as-form
    persistent
    :size="ModalSize.LG"
    :title="$t('add-logo-modal.select-company-logo')"
    :confirm-label="submitButtonText"
  >
    <template #activator>
      <Button
        :label="$t('post-modal.select-logo')"
        :size="ButtonSize.SM"
        :variant="ButtonVariant.OUTLINED"
      />
    </template>
    <template #body="{ formId, close }">
      <form
        :id="formId"
        class="text-left"
        method="post"
        @submit.prevent="onSubmit(close)"
      >
        <AddLogoContent v-model="selectedLogo" />
      </form>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import {
  Button,
  ButtonSize,
  ButtonVariant,
  ModalSize,
  Modal,
} from '@exfluential/ui';
import { useQuadrantsStore } from '~/store/quadrants-store';
import { AddLogoContent } from '~/pages/content/my-posts/_components/add-logo-content';

const model = defineModel<string>({ required: true });

const { t } = useI18n();
const quadrantsStore = useQuadrantsStore();

const initiallySelectedLogo = model.value;
const selectedLogo = ref(initiallySelectedLogo);

const submitButtonText = computed<string>(() => {
  return initiallySelectedLogo && initiallySelectedLogo !== selectedLogo.value
    ? t('common.change')
    : t('common.add');
});

const onSubmit = (close: () => void) => {
  quadrantsStore.selectLogo(selectedLogo.value);
  model.value = selectedLogo.value;
  close();
};
</script>
